module.exports = __webpack_public_path__ + "static/media/bonusSpins_3_5.1d1cb3a7.png";